import { AsyncPipe } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FeatureFlags } from 'app/shared/services/feature-flags/feature-flags.const';
import { filter, map, switchMap } from 'rxjs';
import { AbstractFilterDropdownComponent } from 'shared/components/atoms';
import { SitesService } from 'shared/services';
import { SiteLocation } from 'shared/types';
import { FilterDropdownComponent } from '../filter-dropdown/filter-dropdown.component';

@Component({
  selector: 'app-locations-filter-dropdown',
  templateUrl: './locations-filter-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationsFilterDropdownComponent),
      multi: true,
    },
  ],
  imports: [FilterDropdownComponent, AsyncPipe, ReactiveFormsModule],
})
export class LocationsFilterDropdownComponent extends AbstractFilterDropdownComponent<SiteLocation['id'][]> {
  public locationsHierarchyEnabled = this.contextService.isFeatureFlagEnabled(FeatureFlags.LocationsHierarchy);
  public sitesService = inject(SitesService);
  public locationsData$ = this.contextService.siteId.asObservable().pipe(
    filter((siteId) => siteId !== null),
    switchMap((siteId) => this.sitesService.getSiteLocations(siteId, this.locationsHierarchyEnabled)),
    map(({ value }) =>
      value?.locations.map((location) => {
        const parentLocation = value?.locations.find((l) => l.id === location.parentId);
        return {
          value: location.id,
          label: location.name,
          sublabel: parentLocation?.name ?? '',
        };
      }),
    ),
  );

  constructor() {
    super();
    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: SiteLocation['id'][]) => {
      this.onChange(value);
    });
  }
}
